export const URL_REGEX = /(https?:\/\/\S+)/g;
